import styled from 'styled-components';

const DetailedRulesStyled = styled.div`
  .detailed_rules {
    display: flex;
    justify-content: space-between;
    margin-right: 24px;
    .detailed_left {
      display: flex;
      align-items: center;
      .left_bgc {
        width: 10px;
        height: 132px;
        background: #1565c0;
        box-shadow: 4px 4px 6px 0px rgba(0, 0, 0, 0.16);
        border-radius: 12px 0 0 12px;
      }
      .left_content_wrap {
        width: 590px;
        height: 132px;
        background: #ffffff;
        box-shadow: 4px 4px 6px 0px rgba(0, 0, 0, 0.16),
          0px 0px 6px 0px rgba(0, 0, 0, 0.08);
        border-radius: 0 12px 12px 0;
        padding: 25px 32px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .tooltip_wrap {
          display: flex;
          align-items: flex-start;
          font-size: 24px;
          font-weight: 600;
          color: #212121;
          line-height: 33px;
          .tooltip_content {
            margin: -10px 0 0 5px;
          }
        }
        .content_regular {
          font-size: 16px;
          font-weight: 400;
          color: #616161;
          line-height: 22px;
          cursor: pointer;
        }
      }
      .left_content_paly {
        width: 80px;
        height: 80px;
        background: ${(props) => (props.start ? '#1565C0' : '#616161')};
        display: flex;
        cursor: pointer;
        align-items: center;
        justify-content: center;
        .play_icon {
          width: 47px;
          height: 47px;
          margin: auto;
        }
      }
    }
    .detailed_right {
      width: 132px;
      height: 132px;
      background: ${(props) =>
        props.calculate && props.start ? '#1565C0' : '#FFFFFF'};
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: ${(props) =>
        props.calculate && props.start ? 'pointer' : 'not-allowed'};
      padding: 45px 0 4px;
      gap: 14px;
      .band_calculate {
        width: 35px;
        height: 49px;
      }
      span {
        font-size: 14px;
        font-weight: 400;
        color: ${(props) =>
          props.calculate && props.start ? '#fff' : '#CCCCCC'};
        line-height: 20px;
      }
    }
  }
`;
export default DetailedRulesStyled;
